import { Row, Col } from "react-bootstrap";
import "./HobbiesPerson.css";

function HobbiesPerson({
  id,
  firstName,
  lastName,
  language,
  profileName,
  profileNameEnglish,
}) {
  return (
    <Col className="hobbiesPerson">
      <Row id={id} className="align-items-center">
        <Col>
          <h5>{`${firstName} ${lastName}`}</h5>
          <p>{language === "en" ? profileNameEnglish : profileName}</p>
        </Col>
      </Row>
    </Col>
  );
}

export default HobbiesPerson;
